/* ==========================================================================
   Harper Reborn — <hp-quantity-breaks> ("Toplu Alım İndirimi" block)

   Markup (rendered by main-product.liquid):
     <hp-quantity-breaks data-section data-price data-compare data-variant
                         data-money-format data-default data-available>
       <label class="hp-pb-qb__tier" data-tier="1" data-qty="2" data-pct="10" data-code="AL2">
         <input type="radio"> … <b data-qb-total> <s data-qb-strike> <small data-qb-unit>
   Behaviour:
     - prices are computed client-side from the selected variant (variantChange)
     - picking a tier sets #Quantity-{section} (Dawn's quantity input) and fires
       `change` so Dawn's quantity rules / price-per-item stay in sync
     - the tier's discount code is queued via HP.cart.queue(); hp-cart-extras.js
       applies it right after the add-to-cart succeeds ('-' = remove ours)
     - dispatches a bubbling `hp:qb:change` {qty,pct,code,unit,total,unitText,totalText}
       consumed by the sticky bar (harper-motion.js) and the button price
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;

  class HpQuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.fmt = this.dataset.moneyFormat || (window.HP && window.HP.moneyFormat) || '{{amount}}';
      this.price = parseFloat(this.dataset.price || '0');
      this.compare = parseFloat(this.dataset.compare || '0');
      this.available = this.dataset.available !== 'false';
      this.tiers = [].slice.call(this.querySelectorAll('[data-tier]'));
      this.input = doc.getElementById('Quantity-' + this.section);
      this.selected = null;
      this.money = (c) => (window.HP && window.HP.money ? window.HP.money(c, this.fmt) : String(Math.round(c) / 100));

      // The radios are the source of truth: a label click, a keyboard arrow or a
      // programmatic .click() all end up as one `change` on the radio.
      this.onTierChange = (e) => {
        if (e.target.type !== 'radio') return;
        var tier = e.target.closest('[data-tier]');
        if (!tier) return;
        if (tier.classList.contains('is-unavailable')) {
          if (this.selected) this.apply(this.selected, false);
          return;
        }
        this.apply(tier, true);
      };
      this.addEventListener('change', this.onTierChange);

      if (this.input) {
        this.onInput = () => this.syncFromInput();
        this.input.addEventListener('change', this.onInput);
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        // Dawn's product-info resets the quantity input to its min in setQuantityBoundries()
        // (on connect, after cart updates and before every variantChange) and announces it
        // with quantityUpdate — put the selected tier's quantity back.
        this.unsubQty = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
          if (!this.selected || !this.input) return;
          requestAnimationFrame(() => {
            this.paint();
            if (this.selected.classList.contains('is-unavailable')) this.pickDefault(false);
            else if (parseInt(this.input.value, 10) !== this.tierData(this.selected).qty) this.apply(this.selected, false);
          });
        });
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          var v = event && event.data ? event.data.variant : null;
          if (v) {
            this.price = parseFloat(v.price) || 0;
            this.compare = parseFloat(v.compare_at_price) || 0;
            this.available = v.available !== false;
            this.dataset.variant = v.id;
          } else {
            this.available = false;
          }
          // product-info has just reset the quantity input to its min; re-apply after paint.
          requestAnimationFrame(() => {
            this.paint();
            if (this.selected && !this.selected.classList.contains('is-unavailable')) this.apply(this.selected, false);
            else this.pickDefault(false);
          });
        });
      }

      this.paint();
      this.pickDefault(false);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onTierChange);
      if (this.input && this.onInput) this.input.removeEventListener('change', this.onInput);
      if (this.unsub) this.unsub();
      if (this.unsubQty) this.unsubQty();
    }

    rules() {
      var min = 1, max = Infinity, step = 1;
      if (this.input) {
        min = parseInt(this.input.getAttribute('min') || this.input.dataset.min || '1', 10) || 1;
        var mx = this.input.getAttribute('max') || this.input.dataset.max;
        max = mx ? parseInt(mx, 10) : Infinity;
        step = parseInt(this.input.getAttribute('step') || '1', 10) || 1;
      }
      return { min: min, max: max, step: step };
    }

    tierData(tier) {
      return {
        qty: parseInt(tier.dataset.qty || '1', 10) || 1,
        pct: parseFloat(tier.dataset.pct || '0') || 0,
        code: (tier.dataset.code || '').trim()
      };
    }

    paint() {
      var r = this.rules();
      this.classList.toggle('is-unavailable-variant', !this.available);
      this.tiers.forEach((tier) => {
        var d = this.tierData(tier);
        var unit = Math.round((this.price * (100 - d.pct)) / 100);
        var total = unit * d.qty;
        var ref = (this.compare > this.price ? this.compare : this.price) * d.qty;
        var totalEl = tier.querySelector('[data-qb-total]');
        var strike = tier.querySelector('[data-qb-strike]');
        var unitEl = tier.querySelector('[data-qb-unit]');
        if (totalEl) totalEl.textContent = this.money(total);
        if (strike) {
          strike.hidden = !(ref > total);
          strike.textContent = this.money(ref);
        }
        if (unitEl) {
          unitEl.hidden = d.qty < 2;
          unitEl.textContent = 'adet başı ' + this.money(unit);
        }
        var bad = d.qty < r.min || d.qty > r.max || (d.qty - r.min) % r.step !== 0 || !this.available;
        tier.classList.toggle('is-unavailable', bad);
        tier.setAttribute('aria-disabled', bad ? 'true' : 'false');
        var radio = tier.querySelector('input[type="radio"]');
        if (radio) radio.disabled = bad;
        tier.title = bad && this.available ? 'Bu ürün için uygun değil' : '';
      });
    }

    pickDefault(user) {
      var want = this.dataset.default || '1';
      var tier = this.tiers.filter((t) => t.dataset.tier === want && !t.classList.contains('is-unavailable'))[0];
      if (!tier) tier = this.tiers.filter((t) => !t.classList.contains('is-unavailable'))[0];
      if (tier) this.apply(tier, user);
      else this.deselect();
    }

    apply(tier, user) {
      var d = this.tierData(tier);
      this.selected = tier;
      this.tiers.forEach((t) => {
        var on = t === tier;
        t.classList.toggle('is-selected', on);
        var radio = t.querySelector('input[type="radio"]');
        if (radio) radio.checked = on;
      });
      if (this.input && parseInt(this.input.value, 10) !== d.qty) {
        this.input.value = d.qty;
        this.silent = true;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.silent = false;
      }
      this.queueCode(d.code);
      var unit = Math.round((this.price * (100 - d.pct)) / 100);
      var total = unit * d.qty;
      this.emit({
        qty: d.qty,
        pct: d.pct,
        code: d.code,
        unit: unit,
        total: total,
        unitText: this.money(unit),
        totalText: this.money(total)
      });
      if (user) tier.focus && tier.focus();
    }

    deselect() {
      this.selected = null;
      this.tiers.forEach((t) => {
        t.classList.remove('is-selected');
        var radio = t.querySelector('input[type="radio"]');
        if (radio) radio.checked = false;
      });
      this.queueCode('');
      this.emit({});
    }

    // The customer used Dawn's +/- buttons: select the matching tier or none.
    syncFromInput() {
      if (this.silent) return;
      var qty = parseInt(this.input.value, 10);
      var hit = this.tiers.filter((t) => parseInt(t.dataset.qty, 10) === qty && !t.classList.contains('is-unavailable'))[0];
      if (hit) {
        if (hit !== this.selected) this.apply(hit, false);
      } else if (this.selected) {
        this.deselect();
      }
    }

    // '-' tells hp-cart-extras to drop the code we applied earlier, if any. hp-cart-extras.js
    // is a deferred script at the end of <body>, so on first paint HP.cart may not exist yet.
    queueCode(code) {
      var run = () => {
        if (!window.HP || !window.HP.cart) return;
        window.HP.cart.queue(code || (window.HP.cart.applied() ? '-' : ''));
      };
      if (window.HP && window.HP.cart) run();
      else doc.addEventListener('DOMContentLoaded', run, { once: true });
    }

    emit(detail) {
      this.dispatchEvent(new CustomEvent('hp:qb:change', { bubbles: true, detail: detail }));
    }
  }

  if (!customElements.get('hp-quantity-breaks')) customElements.define('hp-quantity-breaks', HpQuantityBreaks);
})();
